import { Chip, useTheme } from '@mui/material';

import { formatDate } from 'src/utils/utils';

const ExpiryDateChip = ({ date }: { date: Date }) => {
    const theme = useTheme();
    const dateString = formatDate({ date, format: 'YYYY-MM-DD' });
    const currentDate = new Date();

    const colourPallets = () => {
        const oneMonthFromNow = new Date(currentDate);
        oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
        const hasPassed = date.getTime() <= oneMonthFromNow.getTime();
        if (!hasPassed) {
            return {
                borderColor: theme.palette.orange.main,
                backgroundColor: 'rgba(253, 200, 0, 0.3)',
                color: theme.palette.orange.main,
            };
        }
        return {
            borderColor: theme.palette.warning.medium,
            backgroundColor: 'rgba(199, 21, 21, 0.3)',
            color: theme.palette.warning.medium,
        };
    };

    return (
        <Chip
            label={dateString}
            variant="outlined"
            data-testid="expiry-date-chip"
            sx={{
                height: '24px',
                borderWidth: 2,
                fontWeight: 500,
                fontSize: '0.75rem',
                border: '1px solid',
                '& .MuiChip-label': {
                    padding: '0 8px',
                },
                width: '80%',
                textAlign: 'center',
                ...colourPallets(),
            }}
        />
    );
};
export default ExpiryDateChip;
